"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
exports.finalizingTransformersModule = new inversify_1.ContainerModule((bind) => {
});
